import type { BakeryNow } from '@/types'

import { useEffect, useState } from 'react'
import { getBakeryNow } from '@/lib/hours'

import { bakery } from '@/constants/site'

// The bakery's local date and time, refreshed every 30 seconds.
// Returns null during the server render and the first client render, so the
// markup always matches; anything time-based renders once this is set.
export const useBakeryClock = (): BakeryNow | null => {
    const [now, setNow] = useState<BakeryNow | null>(null)

    useEffect(() => {
        const update = (): void => setNow(getBakeryNow(bakery.timezone))

        update()

        const interval = window.setInterval(update, 30000)

        return () => window.clearInterval(interval)
    }, [])

    return now
}
